import React from 'react';
import { BoundSelect } from "../BoundSelect";
import { GateEventValidationError } from "../../../../constants/securspace-constants";

type BoundGateEventValidationErrorSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundGateEventValidationErrorSelect = <T,>({
  label = "Event Validation Error",
  name,
  value = '',
  onChange
}: BoundGateEventValidationErrorSelectProps<T>) => {

  return <BoundSelect<T>
    options={GateEventValidationError}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundGateEventValidationErrorSelect };